import "./turnover.css";
import { useMemo, useState } from "react";
import { DateRangeProps, OperationArea, OperationItem } from "../area";
import { useDashboardSummary, useLanguage } from "../../../hooks";
import { OperationStatistics } from "../graphics";
import { vars } from "../../../assets";
import { RouterEnum } from "../../../router";
import { ReportsTabEnum } from "../../../screens";
import { getCurrentMonthToTodayRange, toChartRows } from "../../../utils";

const formatCurrency = (value: number): string => `${value.toLocaleString("es-ES")}€`;

const OperationTurnover: React.FC = () => {
  const { t } = useLanguage();
  const [dateRange, setDateRange] = useState<DateRangeProps>(
    getCurrentMonthToTodayRange()
  );

  // Agregado en el back sobre todo el periodo. "all" une las operaciones de sus
  // canales y de sus productos cuando la cuenta es marca y canal a la vez.
  const { summary } = useDashboardSummary("all", dateRange);
  const totalSales = summary.totals.sales;
  const totalRedemptions = summary.totals.redemptions;
  const data = useMemo(
    () => toChartRows(summary.daily, ["sales", "redemptions"]),
    [summary]
  );

  return (
    <OperationArea
      title={`${t.components.operations.turnover.title}`}
      calendar={{
        show: true,
        dateRange: dateRange,
        setDateRange: setDateRange,
      }}
      buttonFooter={{
        show: true,
        text: "Ver informes",
        type: "link",
        link: `${RouterEnum.REPORTS}?tab=${ReportsTabEnum.ReportsStatusCard}`,
      }}
      footer={
        <>
          <section className="turnover-footer">
            <div className="turnover-footer-item">
              <div className="turnover-footer-square orange" />
              <p className="turnover-footer-item-text">
                {t.components.operations.turnover.sales}
              </p>
            </div>
            <div className="turnover-footer-item">
              <div className="turnover-footer-square green" />
              <p className="turnover-footer-item-text">
                {t.components.operations.turnover.redemptions}
              </p>
            </div>
          </section>
        </>
      }
    >
      <section className="turnover-subtitle-wrapper">
        <OperationItem
          title={t.components.operations.turnover.totalSales}
          text={formatCurrency(totalSales)}
        />
        <OperationItem
          title={t.components.operations.turnover.totalRedemptions}
          text={formatCurrency(totalRedemptions)}
        />
      </section>

      <OperationStatistics
        data={data}
        lines={[
          {
            dataKey: "sales",
            color: vars.colorOrange,
            name: t.components.operations.statistics.lineSalesPerDay,
          },
          {
            dataKey: "redemptions",
            color: vars.colorGreen,
            name: t.components.operations.statistics.lineRedemptionsPerDay,
          },
        ]}
        currencySymbol="€"
      />
    </OperationArea>
  );
};

export default OperationTurnover;
